<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <form @submit.prevent="submitForm">
    <p class="text-regular text-center mb-1">{{ linkFormTitle }}</p>

    <b-row>
      <b-form-group
        class="col-12 col-lg"
        :class="{
          'col-lg-6 offset-lg-3': isCustomLink && !showAdvertiserField,
        }"
        label="Tipo de link"
        :label-cols-lg="showAdvertiserField ? null : 3"
      >
        <SearchBox
          :dataObject="linkTypes"
          searchCritery="name"
          displayValue="name"
          idToSelectOptions="value"
          :isInvalid="!!errors.linkType"
          placeholder="Selecione um anunciante"
          v-model="options.linkType"
          :radio="true"
          :hideDeselect="true"
          :hideSearch="true"
          @change="track(options.linkType, 'Selecionou tipo de link')"
        />
        <b-form-invalid-feedback
          v-if="errors.linkType"
          class="d-block"
          v-html="errors.linkType"
        />
      </b-form-group>

      <b-form-group
        v-if="showAdvertiserField"
        class="col-12 col-lg link-form__advertiser-selection"
        label="Anunciante"
      >
        <SearchBox
          :dataObject="activeAndApprovedAdvertisers"
          searchCritery="name"
          displayValue="name"
          idToSelectOptions="id"
          :isInvalid="!!errors.advertiser"
          placeholder="Selecione um anunciante"
          v-model="options.advertiser"
          :radio="true"
          @change="track(selectedAdvertiserName, 'Selecionou anunciante')"
        />
        <b-form-invalid-feedback
          v-if="errors.advertiser"
          class="d-block"
          v-html="errors.advertiser"
        />
      </b-form-group>

      <b-form-group
        v-if="!isCustomLink"
        class="col-12 col-lg"
        label="Categorias"
        :label-cols-lg="showAdvertiserField ? null : 3"
      >
        <SearchBox
          :dataObject="activeCategories"
          searchCritery="name"
          displayValue="name"
          :searchNameAll="'Todas as categorias'"
          idToSelectOptions="id"
          :isInvalid="!!errors.category"
          placeholder="Selecione uma categoria"
          v-model="options.category"
          :radio="true"
          :hideDeselect="true"
          @change="track(selectedCategoryName, 'Selecionou a categoria')"
        />
        <b-form-invalid-feedback
          v-if="errors.category"
          class="d-block"
          v-html="errors.category"
        />
      </b-form-group>
    </b-row>

    <b-row class="align-content-center justify-content-center">
      <b-form-group
        class="text-center mb-1 col-8 col-lg-12 link-form__rules-field"
        v-if="showCompliance"
      >
        <ComplianceField
          v-model="options.rulesAccepted"
          :isInvalid="!!errors.rulesAccepted"
          :rulesModalTrackLabel="`regras de divulgação_${advertiser.name}`"
        >
          <template
            v-slot:rules="{ closeComplianceModal }"
            v-bind:showAllRules="showAllRules"
          >
            <p>
              Antes de gerar o link, atente-se às principais regras de
              divulgação do programa:
            </p>
            <ul>
              <li>
                O afiliado não pode se passar por representante comercial do
                PagBank ou funcionário UOL/PagBank. As menções aos produtos
                e marcas do grupo UOL devem ser feitas em terceira pessoa;
              </li>
              <li>
                Não é permitido nas URLs e títulos de seus sites, blogs ou
                páginas de redes sociais os nomes de produtos e marcas do grupo
                UOL/PagBank;
              </li>PagBank
              <li>
                Não é permitida a utilização de logotipos do grupo UOL e/ou
                PagBank em sua divulgação, bem como a imagem dos atores e
                cantores que estrelam peças publicitárias da marca;
              </li>
              <li>
                É proibido plagiar conteúdo de páginas oficiais do PagBank ou
                de outros afiliados, bem como divulgar seus links em publicações
                que não são suas.
              </li>
            </ul>
            <p>
              Caso as regras não sejam respeitadas, sua conta poderá ser
              cancelada sem aviso prévio conforme rege o nosso contrato.
            </p>
            <p>
              <span>Consulte todas as regras </span>
              <b-button
                v-if="itsAlreadyInCampaignPage"
                variant="link"
                class="text-decoration-none link align-baseline p-0"
                @click="
                  closeComplianceModal();
                  showAllRules();
                "
              >
                aqui
              </b-button>
              <span v-else>do anunciante na aba de Campanhas</span>
              <span>.</span>
            </p>
          </template>
        </ComplianceField>
        <b-form-invalid-feedback
          v-if="errors.rulesAccepted"
          class="d-block text-center mt-0"
          v-html="errors.rulesAccepted"
        ></b-form-invalid-feedback>
      </b-form-group>

      <b-col cols="12" class="text-center mt-4" v-show="!showStep2">
        <b-button
          class="go-to-step-2 main-action-button"
          type="submit"
          variant="orange"
          size="lg"
          @click.prevent="validateFormStep1()"
        >
          Continuar
        </b-button>
      </b-col>
    </b-row>

    <b-row v-show="showStep2" class="link-form__step-2">
      <b-form-group v-if="isCustomLink" class="col-12">
        <template v-slot:label>
          <span>Informe a URL </span>
          <span class="text-disabled small"> (Ex.: http://www.uol.com.br)</span>
        </template>
        <b-form-input
          class="link-form__custom-link"
          placeholder="Informe uma URL"
          :isInvalid="!!errors.link"
          v-model="options.customUrl"
        />
        <b-form-invalid-feedback
          v-if="errors.link"
          class="d-block"
          v-html="errors.link"
        />
      </b-form-group>

      <b-form-group v-if="!isCustomLink" class="col-12 col-lg" label="Campanha">
        <SearchBox
          class="link-form__link-list"
          :dataObject="links"
          searchCritery="campaign"
          displayValue="campaign"
          idToSelectOptions="link_id"
          :isInvalid="!!errors.link"
          placeholder="Selecione um link pronto"
          v-model="options.link"
          :radio="true"
          @change="track(options.link, 'Selecionou um link pronto')"
        />
        <b-form-invalid-feedback
          v-if="errors.link"
          class="d-block"
          v-html="errors.link"
        />
      </b-form-group>

      <b-form-group
        class="col-12 col-lg"
        label="Site"
        v-if="!affiliateHasPostback"
      >
        <SearchBoxSites
          v-model="options.site"
          @change="track(options.site, 'Selecionou site')"
        />
        <b-form-invalid-feedback
          v-if="errors.site"
          class="d-block"
          v-html="errors.site"
        />
      </b-form-group>

      <b-form-group class="col-12 col-lg">
        <template v-slot:label>
          <span>Identificador </span>
          <span class="text-disabled small"> (Opcional) </span>
          <b-img
            fluid
            src="@/assets/images/icon_info.svg"
            alt="Info"
            v-b-popover.hover.top="{
              customClass: 'custom-info-popover',
              content:
                'Nome dado para marcar uma peça gerada de acordo com a sua preferência.',
            }"
          >
          </b-img>
        </template>
        <SearchBox
          :dataObject="affiliateLabels"
          searchCritery="desLabel"
          idToSelectOptions="idtUserSupplierLabel"
          displayValue="desLabel"
          placeholder="Selecione um identificador"
          v-model="options.label"
          :radio="true"
          @change="track(options.label, 'Selecionou um identificador')"
          :class="!affiliateInfo ? 'loading-placeholder' : ''"
        />
        <template v-slot:description>
          <b-button
            variant="link"
            size="sm"
            class="text-decoration-none info-identifier pl-0"
            @click.stop="
              toggleControls();
              track('toggleControls', 'Abriu seletor de identificadores');
              track(
                `configurar identificador_${
                  usePageAdvertiser ? advertiser.name : selectedAdvertiserName
                }`
              );
            "
          >
            Configurar identificador
          </b-button>
        </template>
      </b-form-group>

      <b-col cols="12" class="text-center mt-4" v-show="!trackedLink">
        <b-button
          type="submit"
          variant="orange"
          size="lg"
          class="main-action-button"
          @click.passive="track('Gerar link')"
        >
          Continuar
        </b-button>
      </b-col>
    </b-row>

    <section class="link-form__result" v-if="trackedLink">
      <b-row class="mb-1">
        <b-col cols="12">
          <label>URL Completa</label>
        </b-col>

        <b-col cols="12">
          <b-row>
            <b-col cols="12" lg="10">
              <b-form-group class="position-relative mb-0">
                <b-textarea
                  :class="['w-100', 'h-100']"
                  :readonly="true"
                  :draggable="false"
                  rows="5"
                  :value="trackedLink"
                  ref="trackedLinkElement"
                />
                <div
                  class="copy-overlay flex-column"
                  :class="[linkCopied ? 'visible slow-fade-out' : 'invisible']"
                >
                  <b-img
                    class="copy-img"
                    src="@/assets/copy_check.svg"
                    alt="Assunto copiado"
                  ></b-img>
                  <span class="copy-msg ml-1">URL copiada com sucesso</span>
                </div>
              </b-form-group>
            </b-col>
            <b-col class="pl-lg-0">
              <b-button
                variant="grey-shadowed"
                @click="
                  copyLink();
                  track('Copiou o link');
                  track(
                    `copiar url_links prontos ou personalizados_${
                      usePageAdvertiser
                        ? advertiser.name
                        : selectedAdvertiserName
                    }`
                  );
                "
                class="w-100 h-100"
              >
                Copiar URL
              </b-button>
            </b-col>
          </b-row>
        </b-col>

        <b-col v-if="affiliateHasPostback">
          <div class="d-flex align-items-center postback-warn mt-1">
            <b-img
              class="pr-2"
              src="@/assets/warning_icon.png"
              alt="Atenção"
            ></b-img>
            <span>Não se esqueça de substituir os parâmetros do link</span>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col cols="12" lg="6">
          <b-link
            href="https://blog.afiliados.uol.com.br/como-divulgar-seus-links-e-banners-em-redes-sociais-e-sites/"
            target="_blank"
            class="d-flex justify-items-center align-items-center text-decoration-none text-warning how-to px-4 py-2 h-100"
          >
            <b-img
              src="@/assets/images/help.svg"
              alt="Dúvidas?"
              class="mr-2"
            ></b-img>
            <div>
              <strong>Tem dúvidas em como divulgar seus anúncios?</strong>
              Veja aqui algumas dicas
            </div>
          </b-link>
        </b-col>
        <b-col cols="12" lg="6" class="mt-3 mt-lg-0">
          <div
            class="justify-items-center align-items-center text-warning border-light rounded px-4 py-2 h-100"
          >
            <b-row>
              <b-col class="flex-shrink-1">
                <strong>Compartilhe sua URL nas redes sociais:</strong></b-col
              >
              <b-col cols="auto">
                <div
                  class="d-flex mx-n2 h-100 justify-items-center align-items-center"
                >
                  <div class="px-2 flex-shrink-1">
                    <b-link
                      href="#"
                      @click="
                        shareOn(sm.facebook);
                        track('Clicou para divulgar no facebook');
                      "
                    >
                      <b-img
                        src="@/assets/images/facebook.svg"
                        alt="Facebook"
                      ></b-img>
                    </b-link>
                  </div>
                  <div class="px-2 flex-shrink-1">
                    <b-link
                      href="#"
                      @click="
                        shareOn(sm.twitter);
                        track('Clicou para divulgar no twitter');
                      "
                    >
                      <b-img
                        src="@/assets/images/twitter.svg"
                        alt="Twitter"
                      ></b-img>
                    </b-link>
                  </div>
                  <div class="px-2 flex-shrink-1">
                    <b-link
                      href="#"
                      @click="
                        shareOn(sm.whatsapp);
                        track('Clicou para divulgar no whatsapp');
                      "
                    >
                      <b-img
                        src="@/assets/images/whatsapp.svg"
                        alt="WhatsApp"
                      ></b-img>
                    </b-link>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </section>
  </form>
</template>

<script>
import MobileDetect from 'mobile-detect';
import { mapActions, mapGetters } from 'vuex';
// import URLShortener from '@/services/URLShortener';
import HistoryApi from '@/services/history';
import SearchBox from '@/components/SearchBox';
import SearchBoxSites from '@/components/SearchBoxSites';
import ComplianceField from '@/components/ComplianceField';
import {
  generatePostbackParameters,
  b64EncodeUnicode,
} from '@/utils/campaignUtils';

const URLRegEx = /^https?:\/\/\w+(\.\w+)+((\/[\w-#]+)+)?(\.\w+)?(\/)?(\?[\w-./#=&%]+)?(#[\w=&]+)?$/;
const SOCIAL_MEDIAS = Object.freeze({
  facebook: {
    url: 'https://www.facebook.com/sharer/sharer.php?u=',
  },
  twitter: {
    url: 'https://twitter.com/intent/tweet?url=',
    preprocessor: url => url.replace(/\{/g, '[').replace(/\}/g, ']'),
    opts: ['text', 'hashtags', 'via'],
  },
  whatsapp: {
    url: new MobileDetect(window.navigator.userAgent).mobile()
      ? 'https://wa.me?text='
      : 'https://web.whatsapp.com/send?text=',
    opts: ['phone'],
    target: '_blank',
  },
});

export default {
  name: 'LinkForm',
  components: {
    SearchBox,
    SearchBoxSites,
    ComplianceField,
  },
  props: {
    customLink: {
      type: Boolean,
      default: false,
    },
    presetAdvertiser: Object,
    presetLabel: Object,
    usePageAdvertiser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      advertiser: null,
      isFavorite: true,
      showStep2: false,
      options: {
        advertiser: [],
        category: [],
        link: [],
        site: [],
        label: [],
        customUrl: null,
        linkType: ['preset'],
        rulesAccepted: false,
      },
      errors: {
        linkType: null,
        advertiser: null,
        category: null,
        rulesAccepted: null,
        campaign: null,
        link: null,
        site: null,
      },
      trackedLink: null,
      shortLink: null,
      linkCopied: false,
      shortLinkCopied: false,
      loadingShortLink: false,
      sm: SOCIAL_MEDIAS,
      linkTypes: [
        {
          name: 'Links prontos',
          value: 'preset',
        },
        {
          name: 'Links personalizados',
          value: 'custom',
        },
      ],
    };
  },
  computed: {
    selectedAdvertiserCode() {
      if (!this.options.advertiser.length) return '';
      return this.activeAdvertisers.find(
        advertiser => advertiser.id === this.options.advertiser[0],
      ).code;
    },
    selectedAdvertiserName() {
      if (!this.options.advertiser.length) return '';
      return this.activeAdvertisers.find(
        advertiser => advertiser.id === this.options.advertiser[0],
      ).name;
    },
    selectedCategoryName() {
      if (!this.options.category.length) return '';
      return this.activeCategories.find(
        category => category.id === this.options.category[0],
      ).name;
    },
    selectedLink() {
      if (!this.options.link.length) return null;
      return this.links.find(link => link.link_id === this.options.link[0]);
    },
    activeCategories() {
      return this.categories.filter(category => category.active);
    },
    affiliateHasPostback() {
      try {
        return Object.keys(this.affiliateInfo.postbackConfig).length > 0;
      } catch {
        return false;
      }
    },
    linkFormTitle() {
      return this.affiliateHasPostback
        ? 'Selecione o anunciante e categoria para gerar o link.'
        : 'Selecione o anunciante, categoria e URL para gerar o link.';
    },
    ...mapGetters([
      'approvedUrlsByIdt',
      'activeAdvertisers',
      'approvedAdvertisers',
      'allAdvertiserLinks',
      'affiliateInfo',
      'affiliateLabels',
      'pageAdvertiser',
      'affiliateBlockedUrls',
    ]),
    isCustomLink() {
      return this.options.linkType.includes('custom');
    },
    links() {
      if (!this.options.category || !this.options.category.length) return [];
      const currentCategory = this.activeCategories.find(
        category => category.id === this.options.category[0],
      );
      if (currentCategory) {
        const currentCategoryFormats = currentCategory.formats;
        if (currentCategoryFormats) {
          const onlyLinks = currentCategoryFormats.filter(
            fmt => fmt.id === 'links',
          );
          if (onlyLinks) {
            return [].concat(...onlyLinks.map(format => format.links));
          }
        }
      }
      return [];
    },
    showCompliance() {
      if (!this.advertiser) return false;
      return [15, 141, 190].includes(this.advertiser.id);
    },
    activeAndApprovedAdvertisers() {
      const approvedAdvertiserIds = this.approvedAdvertisers.map(
        adv => adv.idtCommissionEventSourceGroup,
      );
      const approvedAdvertisers = this.activeAdvertisers.filter(adv => approvedAdvertiserIds.includes(adv.id));
      return approvedAdvertisers;
    },
    showAdvertiserField() {
      return !this.presetAdvertiser && !this.usePageAdvertiser;
    },
    categories() {
      return this.advertiser ? this.advertiser.campaigns : [];
    },
    itsAlreadyInCampaignPage() {
      return /^\/campanha\/.*/.test(this.$route.path);
    },
  },
  methods: {
    validateFormStep1() {
      let valid = true;

      if (this.options.advertiser.length === 0) {
        this.errors.advertiser = 'Selecione o <strong>anunciante</strong>';
        valid = false;
      }

      if (!this.isCustomLink && this.options.category.length === 0) {
        this.errors.category = 'Selecione a <strong>categoria</strong>';
        valid = false;
      }

      if (!this.options.rulesAccepted && this.showCompliance) {
        this.errors.rulesAccepted = 'Por favor leia e aceite as <strong>Regras de Divulgação</strong>';
        valid = false;
      }

      this.showStep2 = valid;
      return valid;
    },
    validateForm() {
      let valid = true;

      valid = this.validateFormStep1();

      if (!this.affiliateHasPostback && this.options.site.length === 0) {
        this.errors.site = 'Selecione o <strong>site</strong>';
        valid = false;
      }

      if (this.isCustomLink && !URLRegEx.test(this.options.customUrl)) {
        this.errors.link = 'O <strong>link</strong> informado é inválido';
        valid = false;
      }

      if (!this.isCustomLink && this.options.link.length === 0) {
        this.errors.link = 'Selecione a <strong>campanha</strong>';
        valid = false;
      }

      return valid;
    },
    generateLink() {
      const url = new URL('https://click.afiliados.uol.com.br/Clique');

      if (this.affiliateHasPostback) {
        url.searchParams.append(
          'parameters',
          generatePostbackParameters(
            this.advertiser.id,
            this.affiliateInfo.postbackConfig,
          ),
        );
        url.searchParams.append('caf', this.affiliateInfo.codDisplaySupplier);
        url.searchParams.append(
          'cpg',
          btoa(this.affiliateInfo.codDisplaySupplier),
        );
      } else {
        url.searchParams.append('idtUrl', this.options.site[0]);
        url.searchParams.append('cpg', btoa(this.options.site[0]));
      }

      if (this.options.label.length) {
        url.searchParams.append('idtLabel', this.options.label[0]);
      }

      url.searchParams.append('source', this.options.advertiser[0]);
      url.searchParams.append('type', 'link');

      let redirect;
      if (this.isCustomLink) {
        if (this.isBlockedUrl(this.options.customUrl)) {
          const URL_FALLBACK = this.isBlockedUrl(this.options.customUrl);
          redirect = URL_FALLBACK.desFallbackUrl;
        } else {
          redirect = this.options.customUrl;
        }
      } else {
        redirect = this.selectedLink.url;
        url.searchParams.append('creative', b64EncodeUnicode(this.selectedLink.campaign));
      }

      redirect += `${redirect.match(/\?/) ? '&' : '?'}aff_source=${
        this.affiliateInfo.codDisplaySupplier
      }`;

      return `${decodeURIComponent(
        url.toString(),
      )}&affRedir=${encodeURIComponent(redirect)}`;
    },
    isBlockedUrl(url) {
      return this.affiliateBlockedUrls.find(x => x.desUrl === url);
    },
    async submitForm() {
      if (this.isCustomLink) this.track('Gerou link personalizado');
      else this.track('Gerou link pronto');

      if (this.validateForm()) {
        this.linkCopied = false;
        this.shortLinkCopied = false;
        this.shortLink = null;
        this.trackedLink = this.generateLink();

        if (!this.affiliateHasPostback) {
          await this.shortenLink();
        }

        this.saveFormatHistory();
      }
    },
    copyLink() {
      this.linkCopied = false;
      this.$refs.trackedLinkElement.select();
      window.document.execCommand('copy');
      this.$refs.trackedLinkElement.setSelectionRange(0, 0);
      this.$refs.trackedLinkElement.blur();
      setTimeout(() => {
        this.linkCopied = true;
      });
    },
    copyShortLink() {
      this.shortLinkCopied = false;
      this.$refs.shortLinkElement.select();
      window.document.execCommand('copy');
      this.$refs.shortLinkElement.setSelectionRange(0, 0);
      this.$refs.shortLinkElement.blur();
      setTimeout(() => {
        this.shortLinkCopied = true;
      });
    },
    async shortenLink() {
      this.loadingShortLink = true;
      // this.shortLink = await URLShortener.getShortLink(this.trackedLink);
      this.loadingShortLink = false;
    },
    shareOn(shareConfig, optEntries) {
      let url = this.trackedLink;
      if (shareConfig.preprocessor) {
        url = shareConfig.preprocessor(url);
      }
      url = `${shareConfig.url}${encodeURIComponent(url)}`;
      url = url.replace('%7B', '{').replace('%7D', '}');
      if (shareConfig.opts && optEntries) {
        Object.keys(optEntries).forEach((k) => {
          if (shareConfig.opts.indexOf(k) > -1) {
            url += `&${k}=${optEntries[k]}`;
          }
        });
      }
      window.open(
        url,
        shareConfig.target || 'popup',
        shareConfig.target
          ? null
          : 'width=600,height=400,location=0,menubar=0,resizable=0,scrollbars=0,status=0,titlebar=0,toolbar=0',
      );
    },
    clearFormFields() {
      this.options.advertiser = [];
      this.options.category = [];
      this.options.link = [];
      this.options.site = [];
      this.options.label = [];
      this.options.customUrl = null;
    },
    showAllRules() {
      this.$emit('showAllRules');
    },
    async saveFormatHistory() {
      let category = [];
      let description = [];
      if (this.isCustomLink) {
        category = [null];
        description = [null];
      } else {
        category = this.activeCategories
          .filter(activeCategory => activeCategory.id === this.options.category[0])
          .map(activeCategory => activeCategory.name);
        description = this.links
          .filter(link => link.link_id === this.options.link[0])
          .map(link => link.campaign);
      }
      const payload = {
        idtPerson: this.affiliateInfo.idtPerson,
        idtProductSource: this.options.advertiser[0],
        idtFormat: null,
        format: this.linkTypes
          .filter(type => type.value === this.options.linkType[0])
          .map(type => type.name)[0],
        category: category[0],
        description: description[0],
        content: this.trackedLink,
        label: this.affiliateLabels
          .filter(
            label => label.idtUserSupplierLabel === this.options.label[0],
          )
          .map(label => label.desLabel)[0],
        site: this.approvedUrlsByIdt
          .filter(site => site.idtUserSupplierUrl === this.options.site[0])
          .map(site => site.desUrl)[0],
      };
      await HistoryApi.insertHistory(payload);
    },
    ...mapActions([
      'fetchAdvertisers',
      'fetchAdvertiserLinks',
      'getApprovedUrlsByIdt',
    ]),
  },
  async created() {
    if (this.showAdvertiserField) {
      await this.fetchAdvertisers();
    }
  },
  beforeMount() {
    if (this.usePageAdvertiser) {
      this.options.advertiser = [this.pageAdvertiser.id];
      this.advertiser = this.pageAdvertiser;
    }
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.trackedLink = null;
        this.shortLink = null;
      },
    },
    advertiser: {
      handler(value) {
        if (value !== null) {
          this.getApprovedUrlsByIdt(value.id.toString());
        }
      },
    },
    'options.advertiser': {
      async handler() {
        if (!this.showAdvertiserField) return;

        this.errors.advertiser = null;
        if (this.selectedAdvertiserCode) {
          if (!this.allAdvertiserLinks[this.selectedAdvertiserCode]) {
            await this.fetchAdvertiserLinks(this.selectedAdvertiserCode);
          }

          this.advertiser = this.allAdvertiserLinks[
            this.selectedAdvertiserCode
          ];
        } else {
          this.advertiser = null;
        }

        this.options.category = [];
        this.options.site = [];
        this.options.link = [];
        this.options.customUrl = null;
      },
    },
    'options.category': {
      handler() {
        this.options.link = [];
        this.errors.category = null;
      },
    },
    'options.site': {
      handler() {
        this.errors.site = null;
      },
    },
    'options.link': {
      handler() {
        this.errors.link = null;
      },
    },
    'options.customUrl': {
      handler() {
        this.errors.link = null;
      },
    },
    customLink: {
      handler(value) {
        this.clearFormFields();
        this.options.linkType = value ? 'custom' : 'ready';
      },
    },
    'options.rulesAccepted': {
      handler(value) {
        if (!value) {
          this.showStep2 = value;
        }
        this.errors.rulesAccepted = null;
      },
    },
    presetAdvertiser: {
      immediate: true,
      handler(advertiser) {
        if (advertiser) {
          this.options.advertiser = [advertiser.id];
          this.advertiser = advertiser;
        }
      },
    },
    presetLabel: {
      immediate: true,
      handler(label) {
        if (label) {
          this.options.label = [label.idtUserSupplierLabel];
        }
      },
    },
    'options.label': {
      handler(selectedLabels) {
        const selectedLabel = this.affiliateLabels.find(label => selectedLabels.includes(label.idtUserSupplierLabel));
        this.$emit('labelUpdated', selectedLabel);
      },
    },
  },
  inject: ['toggleControls'],
};
</script>

<style lang="scss" scoped>
.link-wrapper {
  /deep/ {
    label[for="link"] {
      font-weight: bold;
      text-align: center;
    }
  }
}
.loader {
  background: $bg-default;
  z-index: 2;
}
.how-to {
  @include rounded();
  background: $wild-sand;
}

.btn-favorite {
  width: 40px;
  height: 34px;
  background-image: url("~@/assets/star_yellow.png") !important;
  background-repeat: no-repeat !important;
}
.btn-no-favorite {
  width: 40px;
  height: 34px;
  background-image: url("~@/assets/star.svg");
  background-repeat: no-repeat;
}
</style>
